module.exports = __webpack_public_path__ + "img/govpage_3.0a521d99.svg";